import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Filter } from '../models/filter';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ResponseModel } from '../models/response-model';
import { EquipmentRegistration } from '../models/equipment-registration';
import { Paging } from '../models/page';

@Injectable({
  providedIn: 'root'
})
export class EquipmentRegistrationService {
  private url = `${environment.url}/equipmentRegistration`;
  constructor(private http: HttpClient) { }

  readEquipmentRegistration(filter: Filter<{ orderCode?: string }>) {
    let params = new HttpParams();
    params = params
      .set('page', filter.page.toString() || '0')
      .set('pageSize', filter.pageSize.toString() || '20');

    params = filter.value.orderCode ? params.set("associatedOrder", filter.value.orderCode) : params;

    return this.http.get<ResponseModel<Paging<Array<EquipmentRegistration>>>>(this.url, { params });
  }
}
